import React from 'react';

const Button = (props) => {

    const {className, disabled, description, onClick, title, id} = props;

    return (
        <input className={className} disabled={disabled} title={title} id={id} type="button" value={description}
               onClick={onClick}/>
    )
};

export default Button;
